var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSucheSchliessen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Suche_Schliessen__Icn/40px/Suche_Schliessen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Suche_Schliessen__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Suche_Schliessen__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18,8 C22.9705627,8 27,12.0294373 27,17 C27,19.124779 26.2636898,21.0775836 25.0323074,22.6171757 L32.2426407,29.8284271 L30.8284271,31.2426407 L23.6171757,24.0323074 C22.0775836,25.2636898 20.124779,26 18,26 C13.0294373,26 9,21.9705627 9,17 C9,12.0294373 13.0294373,8 18,8 Z M18,10 C14.1340068,10 11,13.1340068 11,17 C11,20.8659932 14.1340068,24 18,24 C21.8659932,24 25,20.8659932 25,17 C25,13.1340068 21.8659932,10 18,10 Z",
    id: ".._.._src_svg_Icn_40px_Suche_Schliessen__Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4852814,13 L21.8994949,14.4142136 L19.364,16.95 L21.8994949,19.4852814 L20.4852814,20.8994949 L17.95,18.364 L15.4142136,20.8994949 L14,19.4852814 L16.536,16.95 L14,14.4142136 L15.4142136,13 L17.95,15.536 L20.4852814,13 Z",
    id: ".._.._src_svg_Icn_40px_Suche_Schliessen__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucheSchliessen);
export default __webpack_public_path__ + "static/media/Suche_Schliessen.9b1a8c31ba4fd164b4c97e5341ef53bf.svg";
export { ForwardRef as ReactComponent };